import { EVENT_CONFIRMATION, EVENTS_THAT_NEED_CONFIRMATION, HISTORY_EVENT } from "../../models/eventTypes";


const isAnOpenCloseEvent = (
  currentEventItem: TranslationHistoryItem,
  nextEventItem: TranslationHistoryItem
) => {
  if (!nextEventItem) {
    return false;
  }

  return EVENTS_THAT_NEED_CONFIRMATION.includes(currentEventItem.eventType)
    && EVENT_CONFIRMATION.includes(nextEventItem.eventType)
}

export interface GroupHistoryItem {
  latestEventType: HistoryEventType
  isPending: boolean
  isConnected: boolean
  isDeclined: boolean
  events: TranslationHistoryItem[]
  isDeactivated: boolean 
  reactivatedTranslation: string | null
}

const findReactivatedTranslation = (items: TranslationHistoryItem[], reactivatedIndex: number): string | null => {
  const remainingItems = items.slice(reactivatedIndex + 1);
  
  const deactivatedIndex = remainingItems.findIndex(
    item => item.eventType === HISTORY_EVENT.Deactivated || item.eventType === HISTORY_EVENT.Deactivation
  );
  
  if (deactivatedIndex === -1) return null;
  
  const itemWithValue = remainingItems.slice(deactivatedIndex + 1).find(item => item.newValue);
  
  return itemWithValue?.newValue ?? null;
};

const formatEventTitle = (title: string): string => {
  const cleaned = title.replace(/^String /, '');
  return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
}

export const createHistoryEventTree = (items: TranslationHistoryItem[]) => {
  const visitedIndexes: Record<number, boolean> = {}
  const groupHistoryEvents: GroupHistoryItem[] = []

  // The logic works better if the tackle the events in reverse mode
  for (let i = items.length - 1; i >= 0; i--) {
    if (visitedIndexes[i]) {
      continue;
    }

    const event = {
      ...items[i],
      title: formatEventTitle(items[i].title)
    };
    const nextEvent = items[i - 1];
    const group = [event];
    let isDeclined = false;
    let isDeactivated = false;
    let reactivatedTranslation: string | null = null;


    if (event.eventType === HISTORY_EVENT.Reactivated || event.eventType === HISTORY_EVENT.Reactivation) {
      reactivatedTranslation = findReactivatedTranslation(items, i);
    }

    if (isAnOpenCloseEvent(event, nextEvent)) {
      visitedIndexes[i - 1] = true;
      const formattedNextEvent = {
        ...nextEvent,
        title: formatEventTitle(nextEvent.title)
      };
      group.unshift(formattedNextEvent);
      isDeclined = nextEvent.eventType === HISTORY_EVENT.Declined;
      isDeactivated = nextEvent.eventType === HISTORY_EVENT.Deactivated || nextEvent.eventType === HISTORY_EVENT.Deactivation;
    }

    groupHistoryEvents.push({
      latestEventType: group[0].eventType, // Only interested in the newest one
      isPending: false,
      isConnected: true,
      events: group,
      isDeclined,
      isDeactivated,
      reactivatedTranslation
    });
  }

  // Mutable element
  groupHistoryEvents.reverse();

  // Verify if the latest event still need some approvals or decline
  if (EVENTS_THAT_NEED_CONFIRMATION.includes(groupHistoryEvents[0].latestEventType)) {
    groupHistoryEvents[0].isPending = true;
  }

  // Generate timeline connection for the rest of elements except for the last one
  groupHistoryEvents[groupHistoryEvents.length - 1].isConnected = false;

  return groupHistoryEvents
}
